// Datos ficticios de ejemplo — plantilla "Aventura Espacial" (cumpleaños infantil).
// Ilustraciones originales (cohete, planeta, estrellas); sin personajes comerciales.

export const datosEjemplo = {
  tipoEvento: "infantil",
  plantillaId: "infantil-espacial",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "Cuenta regresiva", titulo: "Despegamos en", textoFinalizado: "¡Ya despegamos!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Misión", titulo: "Punto de encuentro" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Guardá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Bitácora", titulo: "Fotos de la misión" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El plan de vuelo", titulo: "Qué vamos a hacer" },
    { id: "menciones", visible: false, orden: 6, etiqueta: "Tripulación", titulo: "La tripulación" },
    { id: "video", visible: false, orden: 7, etiqueta: "Video", titulo: "Video de la misión" },
    { id: "musica", visible: true, orden: 8, etiqueta: "Radio espacial", titulo: "Música de la galaxia" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "¿Subís al cohete?" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Centro de control", titulo: "Para los papás" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejá tu mensaje estelar" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  protagonista: {
    nombre: "Valentino",
    edad: 5,
    textoEdad: "años",
    fraseIntroductoria: "¡Despega mi cumple!",
    mensajePortada:
      "Prepará tu traje espacial: vamos a explorar la galaxia con juegos, sorpresas y torta.",
    mensajeCierre:
      "¡Gracias por viajar conmigo en esta misión! Nos vemos en la próxima aventura.",
    textoBotonEntrada: "¡Iniciar la misión!",
  },

  evento: {
    fechaISO: "2027-01-24T16:00:00-03:00",
    fechaLegible: "Domingo 24 de enero de 2027",
    fechaCorta: "24 · 01 · 2027",
    ciudad: "San Lorenzo, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "La Tierra vista desde el espacio",
      },
      {
        src: "https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Despegue de un cohete",
      },
      {
        src: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Nebulosa de colores",
      },
      {
        src: "https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Cielo estrellado",
      },
    ],
  },

  eventos: [
    {
      id: "fiesta",
      etiqueta: "Base espacial",
      lugar: "Salón Arcoíris",
      direccion: "Av. del Agrónomo esq. Mburicao, San Lorenzo",
      horario: "16:00 a 19:00 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=San+Lorenzo+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Cumpleaños de Valentino (5 años)",
    descripcion: "Fiesta de 16:00 a 19:00 h en Salón Arcoíris, San Lorenzo.",
    texto: "Domingo 24 de enero de 2027 · San Lorenzo. ¡Que no se te pase el despegue!",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-01-24T16:00:00-03:00",
    finISO: "2027-01-24T19:00:00-03:00",
    ubicacion: "Salón Arcoíris, San Lorenzo, Paraguay",
  },

  itinerario: [
    { hora: "16:00", titulo: "¡Despegue!", descripcion: "Recibimos a los astronautas.", icono: "brillo" },
    { hora: "16:30", titulo: "Juegos espaciales", descripcion: "Carrera de cohetes y pelotero.", icono: "fiesta" },
    { hora: "17:30", titulo: "Combustible", descripcion: "Merienda para recargar energías.", icono: "cena" },
    { hora: "18:15", titulo: "Piñata asteroide", descripcion: "A romperla entre todos.", icono: "copas" },
    { hora: "18:40", titulo: "La torta", descripcion: "Cantamos el feliz cumpleaños.", icono: "corazon" },
    { hora: "19:00", titulo: "Aterrizaje", descripcion: "Sorpresita de despedida.", icono: "musica" },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play para escuchar la música de la misión. Nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Confirmá tu lugar en la nave: los asientos (y las porciones de torta) son limitados.",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 10 de enero de 2027",
  },

  enlaces: [
    { texto: "Ideas de regalos", url: "https://www.pinterest.com" },
    { texto: "Mapa de la zona", url: "https://www.google.com/maps/search/?api=1&query=San+Lorenzo+Paraguay" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejale un mensaje para su bitácora.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Subí las fotos de la misión.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
